<div class="update-prompt" role="alertdialog" aria-live="assertive">
  <img
    class="update-prompt__icon"
    src="icons/icon-192x192.png"
    width="24"
    height="24"
    alt=""
  />

  <div class="update-prompt__body">
    <strong>نسخه جدید آماده است</strong>
    <p>برای ادامه باید به‌روزرسانی کنید.</p>
    <button
      type="button"
      nttLinkButton
      size="tiny"
      class="update-prompt__action"
      (click)="updater.applyUpdate()"
    >
      به‌روزرسانی
    </button>
    <span class="update-prompt__countdown" role="status">
      خودکار در {{ updater.secondsLeft() }} ثانیه
    </span>
  </div>
</div>
